import { defineMessages } from 'react-intl';

const _default_1: {
	ofTotalCount: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	ofTotalCount: {
		id: 'paginated-picker.async-select.pagination-details.of-total-count',
		defaultMessage: '{itemsCount} of {totalCount}',
		description: 'Total count of items.',
	},
});
export default _default_1;
